import { render, staticRenderFns } from "./LfLabelButtonComponent.vue?vue&type=template&id=18f84d6c&scoped=true"
import script from "./LfLabelButtonComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LfLabelButtonComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./LfLabelButtonComponent.vue?vue&type=style&index=0&id=18f84d6c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f84d6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f84d6c')) {
      api.createRecord('18f84d6c', component.options)
    } else {
      api.reload('18f84d6c', component.options)
    }
    module.hot.accept("./LfLabelButtonComponent.vue?vue&type=template&id=18f84d6c&scoped=true", function () {
      api.rerender('18f84d6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/buttons/label/LfLabelButtonComponent.vue"
export default component.exports